var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.678,
    height: 23,
    viewBox: "0 0 21.678 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4625",
    "data-name": "Path 4625",
    d: "M10.777-12.641a1.02,1.02,0,0,1-.283,1.105L8.549-9.766a8.692,8.692,0,0,1,.076,1.141,8.692,8.692,0,0,1-.076,1.141l1.945,1.77a1.02,1.02,0,0,1,.283,1.105,11.4,11.4,0,0,1-.705,1.541L9.86-2.7A11.836,11.836,0,0,1,8.868-1.3a1.028,1.028,0,0,1-1.1.305l-2.5-.8A9.829,9.829,0,0,1,3.288-.647L2.727,1.918a1.077,1.077,0,0,1-.818.8,11.738,11.738,0,0,1-1.95.157,11.489,11.489,0,0,1-1.869-.157,1.077,1.077,0,0,1-.818-.8L-3.288-.647A8.829,8.829,0,0,1-5.265-1.792l-2.5.8a1.026,1.026,0,0,1-1.1-.305A11.788,11.788,0,0,1-9.859-2.7l-.21-.364a11.2,11.2,0,0,1-.709-1.541,1.021,1.021,0,0,1,.285-1.105l1.943-1.77a8.693,8.693,0,0,1-.075-1.141A8.693,8.693,0,0,1-8.55-9.766l-1.943-1.77a1.019,1.019,0,0,1-.285-1.105,11.258,11.258,0,0,1,.709-1.541l.21-.364a11.637,11.637,0,0,1,.994-1.4,1.02,1.02,0,0,1,1.1-.306l2.5.8A8.639,8.639,0,0,1-3.288-16.6l.562-2.565a1.019,1.019,0,0,1,.818-.8A11.563,11.563,0,0,1,0-20.125a11.563,11.563,0,0,1,1.909.158,1.019,1.019,0,0,1,.818.8L3.288-16.6a9.593,9.593,0,0,1,1.977,1.144l2.5-.8a1.022,1.022,0,0,1,1.1.306,11.63,11.63,0,0,1,.993,1.4l.211.364a11.4,11.4,0,0,1,.705,1.541ZM0-5.031A3.6,3.6,0,0,0,3.594-8.665,3.619,3.619,0,0,0,0-12.259,3.619,3.619,0,0,0-3.594-8.665,3.6,3.6,0,0,0,0-5.031Z",
    transform: "translate(10.84 20.125)",
    fill: "#a2a2a2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.ce750980cf19a8cc6c85ee2a6ef84759.svg";
export { ForwardRef as ReactComponent };